import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import React from "react";

import { QueueFilters } from "./QueueFilters/QueueFilters";
import {
  DeleteQueueButton,
  QueueDetailsRow,
  QueueInfoContainer,
  QueueInfoContent,
  QueueInfoHeader,
} from "./style";

type QueueInfoProps = {
  queueName: string;
  queueUrl: string;
  queueTitle: string;
  filters: string[];
  onDeleteClick: () => void;
  onRemoveAllFiltersClick: () => void;
  fetchIrisDetails: () => void;
};

type PairProps = {
  label: string;
  value: string;
};

const LabelValuePairWithCopyButton: React.FC<PairProps> = ({
  label,
  value,
}) => {
  const id = React.useId();
  const labelId = `label-${id}`;
  const valueId = `value-${id}`;

  return (
    <QueueDetailsRow className="tile is-parent">
      <div className="tile is-child is-2">
        <span id={labelId}>{label}</span>
      </div>
      <div className="tile is-child is-8">
        <span id={valueId} aria-labelledby={labelId}>
          {value}
        </span>
      </div>
      <div className="tile is-child is-2">
        <CopyToClipboard value={value} label={label} />
      </div>
    </QueueDetailsRow>
  );
};

const QueueInfo: React.FC<QueueInfoProps> = ({
  queueName,
  queueUrl,
  queueTitle,
  filters,
  onDeleteClick,
  onRemoveAllFiltersClick,
  fetchIrisDetails,
}) => (
  <QueueInfoContainer>
    <QueueInfoHeader>
      <span>{queueTitle}</span>
      <DeleteQueueButton
        ariaLabel={`Delete queue ${queueTitle}`}
        buttonText="Delete"
        iconName={faTrashAlt}
        onClick={onDeleteClick}
      />
    </QueueInfoHeader>
    <QueueInfoContent>
      <LabelValuePairWithCopyButton label="Queue name" value={queueName} />
      <LabelValuePairWithCopyButton label="Queue URL" value={queueUrl} />
      <QueueFilters
        queueTitle={queueTitle}
        appliedFilters={filters}
        onRemoveAllFiltersClick={onRemoveAllFiltersClick}
        fetchIrisDetails={fetchIrisDetails}
      />
    </QueueInfoContent>
  </QueueInfoContainer>
);

export default QueueInfo;
